import { css, Interpolation, Theme } from '@emotion/react'
// ?no-inline keeps a file URL: Vite would inline this small SVG as a data URI full of ' quotes,
// which breaks the url('') below, so the browser drops the whole mask declaration.
import TableOfContentIcon from 'assets/icons/table-of-content.svg?no-inline'

export const editor: (state: {
  focus?: boolean
  error?: boolean
  withTableOfContent?: boolean
}) => Interpolation<Theme> =
  ({ focus, error, withTableOfContent }) =>
  (theme) =>
    css`
      background: ${theme.backgrounds.backgroundFour};
      border: 1px solid ${focus ? theme.colors.blue : error ? theme.colors.red : theme.backgrounds.backgroundOne};
      box-shadow: ${theme.boxShadows.small};
      border-radius: 14px;

      .ck-toolbar {
        border: none;
        border-bottom: 1px solid ${theme.backgrounds.backgroundOne} !important;
        border-radius: 14px 14px 0 0 !important;
      }

      .ck-source-editing-area {
        max-height: 800px;
      }

      .ck-content,
      .ck-source-editing-area textarea {
        max-height: 800px;
        border-radius: 0 0 14px 14px !important;
        box-shadow: none !important;
        border-top: none !important;
        border-right: none !important;
        border-bottom: none !important;
        border-left: none !important;
        overflow: auto;

        // CONTENT STYLES - same as on the WEB side
        a {
          color: #2a6df4;
          text-decoration: none;
          cursor: pointer;

          &:hover {
            color: #2358c1;
          }
        }

        .ql-align-right {
          text-align: right;
        }

        .ql-align-center {
          text-align: center;
        }

        .ql-align-justify {
          text-align: justify;
        }

        // default font
        font-size: 14px !important;
        line-height: 20px !important;

        .text-tiny {
          font-size: 10px !important;
          line-height: 14px !important;
        }

        .text-small {
          font-size: 12px !important;
          line-height: 16px !important;
        }

        .text-big {
          font-size: 16px !important;
          line-height: 28px !important;
        }

        .text-huge {
          font-size: 18px !important;
          line-height: 34px !important;
        }

        .text-blog-title {
          font-size: 22px !important;
          line-height: 34px !important;
        }

        .text-subtitle {
          font-weight: 700 !important;
        }

        h4 {
          font-size: 48px !important;
          line-height: 60px !important;
          margin: 14px 0 !important;
        }

        h3 {
          font-size: 54px !important;
          line-height: 68px !important;
          margin: 14px 0 !important;
        }

        h2 {
          font-size: 64px !important;
          line-height: 81px !important;
          margin: 14px 0 !important;
        }

        .bar {
          display: inline-block;
          width: 100%;
          padding: 11px;
          text-align: center;
          background: #f3f7fb;
          color: #526ca0;
          font-weight: 700;
          border-radius: 12px;
          font-size: 16px !important;
          line-height: 22px !important;
        }

        figure {
          margin-left: auto;
          margin-right: auto;
          width: fit-content;
        }

        // Preview Image Link - text with attached preview image (similar to link styling)
        .preview-image-link {
          color: #8b5cf6;
          text-decoration: underline;
          text-decoration-style: dashed;
          text-decoration-color: #8b5cf6;
          text-underline-offset: 2px;
          cursor: pointer;
          position: relative;

          &:hover {
            color: #7c3aed;
            text-decoration-color: #7c3aed;
            background-color: rgba(139, 92, 246, 0.1);
            border-radius: 2px;
          }
        }
      }

      .ck-placeholder::before {
        color: ${theme.typographyColors.typographyThree};
      }

      ${withTableOfContent &&
      css`
        *[data-table-of-content] {
          :hover {
            background-color: #f0f7ff;
            border-radius: 2px;
          }

          ::after {
            height: 12px;
            width: 12px;
            content: '';
            mask: url('${TableOfContentIcon}');
            background-color: #2977ff;
            display: inline-block;
            vertical-align: text-top;
            margin: 0 1px;
          }
        }
      `}
    `

export const label: Interpolation<Theme> = (theme) => css`
  width: 100%;
  font-weight: 400;
  font-size: 16px;
  line-height: 20px;
  color: ${theme.typographyColors.typographyThree};
  margin-bottom: 10px;
  cursor: pointer;
`

export const hiddenInput: Interpolation<Theme> = css`
  position: absolute;
  outline: none;
  border: none;
  padding: 0;
  height: 0;
  width: 0;
  opacity: 0;
`
